import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { IconSession } from "./IconSession";
import { useSDK } from "../shared/useSDK";
import {
  Breadcrumb,
  BreadcrumbAligner,
  BreadcrumbLink,
} from "./lib/Breadcrumb";
import { getSessionName } from "../shared/getSessionName";

const listLink = {
  to: "/sessions",
  text: "Sessions",
  icon: <IconSession />,
};

export function BreadcrumbSession() {
  const params = useParams<{ uuid?: string }>();
  return (
    <BreadcrumbAligner>
      <Breadcrumb>
        <BreadcrumbLink to={listLink.to}>
          {listLink.icon}
          <span>{listLink.text}</span>
        </BreadcrumbLink>
        {params.uuid ? <BreadcrumbItem /> : null}
      </Breadcrumb>
    </BreadcrumbAligner>
  );
}

function BreadcrumbItem() {
  const params = useParams<{ uuid: string }>();
  const { sdk } = useSDK();
  const result = useQuery(["session", params.uuid], (key, uuid: string) =>
    sdk.getSession({ sessionUuid: uuid })
  );
  const to = `/sessions/${params.uuid}`;
  const fallbackText = "Session";
  if (result.status === "loading") {
    return null;
  }
  if (result.status === "error" || result.data === undefined) {
    return <BreadcrumbLink to={to}>{fallbackText}</BreadcrumbLink>;
  }
  return (
    <BreadcrumbLink to={to}>{getSessionName(result.data.data)}</BreadcrumbLink>
  );
}
